import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	search: {
		id: 'dynamic-cards-search-page.dropdown_search',
		defaultMessage: 'Search',
		description: 'Subheading text for mimic query search',
	},
	searchIconLabel: {
		id: 'dynamic-cards-search-page.dropdown_search_icon_label',
		defaultMessage: 'Search',
		description: 'Label text for search icon',
	},
});
